<button mat-raised-button color="primary" *appRole="['CaracteristicaPropiedad.Crear']" [routerLink]="['/tiposcaracteristicas']">
    <mat-icon>add</mat-icon>
    Nuevo tipo caracteritica
</button>
